module.exports = __webpack_public_path__ + "img/megaphone-1.00135442.svg";